import { api } from "./configs/axiosConfigs";

export const ReferralsAPI = {
  getReferrals: async () => {
    const response = await api.get(
      `/referrals?page=1&items_per_page=2000&order_by=referral_date&order=desc`,
    );

    return response?.data;
  },

  getReferral: async (id) => {
    const response = await api.get(`/referrals/${id}`);

    return response?.data;
  },

  addReferral: async (form) => {
    const response = await api.post(`/referrals`, form);

    return response?.data;
  },

  updateReferral: async (form, id) => {
    const response = await api.patch(`/referrals/${id}`, form);

    return response?.data;
  },

  deleteReferral: async (id) => {
    const response = await api.delete(`/referrals/${id}`);

    return response?.data;
  },
};
